document.addEventListener("DOMContentLoaded", function () {
    const banner = document.querySelector(".collection-banner");
    const header = document.querySelector(".header.transparent--true");
    
    if (window.innerWidth <= 768) {
        // Verificar si .collection-banner contiene el elemento con la clase específica
        if (banner && header && banner.querySelector(".collection-banner--image-hide-mobile")) {
        // Aplicar estilos a .header.transparent--true
        header.classList.remove("transparent--true");
        banner.classList.remove("collection-banner--has-bg");
        }
    }
});document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("line-item:change:end", async () => {
    // Espera breve para que Shopify procese bien el cambio de línea
    await new Promise(resolve => setTimeout(resolve, 200));

    const cart = await fetch("/cart.js").then(res => res.json());

    const SERVICE_VARIANT_ID = 55553278345481;
    const personalizedItems = cart.items.filter(item => item.properties?.["_knifeGraving"]);
    const serviceItems = cart.items.filter(item => item.variant_id === SERVICE_VARIANT_ID);

    for (const personalized of personalizedItems) {
      const linkedService = serviceItems.find(svc => svc.properties?.["_relatedProduct"] === personalized.variant_id.toString());

      if (!linkedService) continue;

      const maxQuantity = parseInt(linkedService.properties["_maxQuantity"]) || linkedService.quantity;

      if (personalized.quantity < linkedService.quantity) {
        await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: linkedService.key, quantity: personalized.quantity }),
        });
      } else if (personalized.quantity > linkedService.quantity) {
        if (personalized.quantity <= maxQuantity) {
          await fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: linkedService.key, quantity: personalized.quantity }),
          });
        }
      }
    }

    for (const service of serviceItems) {
      const hasProduct = personalizedItems.some(p => p.variant_id.toString() === service.properties?.["_relatedProduct"]);
      if (!hasProduct) {
        await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: service.key, quantity: 0 }),
        });
      }
    }

    document.dispatchEvent(new CustomEvent("cart:refresh"));
  });
});


// document.addEventListener("DOMContentLoaded", function () {
//   const interval = setInterval(() => {
//     const el = document.getElementById("INDShadowRootHost");
//     if (el) {
//       el.style.setProperty("display", "none", "important");
//       clearInterval(interval);
//     }
//   }, 100); // intenta cada 100ms hasta que aparezca
// });


document.addEventListener("DOMContentLoaded", function() {
  var lazyImgs = document.querySelectorAll("img.lazyload");

  lazyImgs.forEach(function(img) {
    if (img.classList.contains("lazyload")) {
      lazySizes.loader.unveil(img);
    }
  });
});


// ==============================
// 1. CARGAR API DE YOUTUBE
// ==============================
var tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
document.head.appendChild(tag);

let players = {}; // almacenar instancias de players

// ==============================
// 2. INICIALIZAR YOUTUBE PLAYERS
// ==============================
function onYouTubeIframeAPIReady() {
  document.querySelectorAll('iframe.js-youtube').forEach((iframe, index) => {
    const id = iframe.id || "yt-player-" + index;
    iframe.id = id;

    players[id] = new YT.Player(id, {
      events: {
        'onStateChange': onPlayerStateChange
      }
    });
  });
}

// ==============================
// 3. MANEJAR EVENTOS YOUTUBE
// ==============================
function onPlayerStateChange(event) {
  const player = event.target;
  const data = event.data;
  const videoData = player.getVideoData();
  const videoUrl = player.getIframe().src;

  if (data === YT.PlayerState.PLAYING) {
    pushToDataLayer(player, videoData, videoUrl, "YouTube");
    trackYTProgress(player, videoData, videoUrl);
  }

  if (data === YT.PlayerState.PAUSED) {
    pushToDataLayer(player, videoData, videoUrl, "YouTube");
  }

  if (data === YT.PlayerState.ENDED) {
    pushToDataLayer(player, videoData, videoUrl, "YouTube", 100);
  }
}

// ==============================
// 4. FUNCIÓN GENERAL PARA DATA LAYER
// ==============================
function pushToDataLayer(playerOrVideo, videoData, videoUrl, provider, percent=null) {
  let duration, current, title;

  if (provider === "YouTube") {
    duration = playerOrVideo.getDuration();
    current = playerOrVideo.getCurrentTime();
    title = videoData.title || "Sin título";
  } else {
    duration = playerOrVideo.duration || 0;
    current = playerOrVideo.currentTime || 0;
    title = videoData.title || "Sin título";
  }

  const percentage = percent ?? Math.round((current / duration) * 100);

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'event': 'video_progress',
    'event_category': 'videos',
    'video_title': title,
    'video_url': videoUrl,
    'video_percent': percentage,
    'video_duration': duration,
    'video_provider': provider
  });

}

// ==============================
// 5. TRACKING DE PROGRESO YOUTUBE
// ==============================
function trackYTProgress(player, videoData, videoUrl) {
  let checkpoints = [25, 50, 75];
  let done = {};

  const interval = setInterval(() => {
    if (player.getPlayerState() !== YT.PlayerState.PLAYING) return;

    const current = player.getCurrentTime();
    const duration = player.getDuration();
    const percent = Math.round((current / duration) * 100);

    checkpoints.forEach(p => {
      if (percent >= p && !done[p]) {
        pushToDataLayer(player, videoData, videoUrl, "YouTube", p);
        done[p] = true;
      }
    });

    if (percent >= 100) clearInterval(interval);
  }, 1000);
}

// ==============================
// 6. TRACKING HTML5 <video>
// ==============================
document.addEventListener("DOMContentLoaded", () => {
  const videos = document.querySelectorAll("video");

  videos.forEach(video => {
    const title = video.getAttribute("title") || "Sin título";
    const url = video.currentSrc || video.src;

    video.addEventListener("play", () => {
      if (video.hasAttribute("autoplay") || video.hasAttribute("loop")) return;
      pushToDataLayer(video, {title}, url, "HTML5");
      trackHTML5Progress(video, {title}, url);
    });

    video.addEventListener("pause", () => {
      if (video.hasAttribute("autoplay") || video.hasAttribute("loop")) return;
      pushToDataLayer(video, {title}, url, "HTML5");
    });

    video.addEventListener("ended", () => {
      if (video.hasAttribute("autoplay") || video.hasAttribute("loop")) return;
      pushToDataLayer(video, {title}, url, "HTML5", 100);
    });
  });
});

function trackHTML5Progress(video, videoData, videoUrl) {
  let checkpoints = [25, 50, 75];
  let done = {};

  const interval = setInterval(() => {
    if (video.paused || video.ended) return;

    const current = video.currentTime;
    const duration = video.duration;
    const percent = Math.round((current / duration) * 100);

    checkpoints.forEach(p => {
      if (percent >= p && !done[p]) {
        pushToDataLayer(video, videoData, videoUrl, "HTML5", p);
        done[p] = true;
      }
    });

    if (video.ended) clearInterval(interval);
  }, 1000);
}


document.addEventListener("DOMContentLoaded", () => {
  const form = document.querySelector("#contact_form");

  if (!form) return;

  form.addEventListener("submit", (e) => {
    e.preventDefault(); // evitar envío inmediato para validar

    let envioCorrecto = form.checkValidity(); // validación nativa HTML5
    let detalleError = envioCorrecto ? "envío ok" : "";

    // Buscar mensaje de error si existe
    if (!envioCorrecto) {
      const invalidInput = form.querySelector(":invalid");
      if (invalidInput) {
        detalleError = invalidInput.title || invalidInput.validationMessage || "Error en el formulario";
      }
    }

    // Enviar evento a dataLayer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'alta_newsletter',
      'event_category': 'formularios',
      'method': 'formulario footer',
      'form_name': 'newsletter',
      'form_submit_text': 'suscribeme',
      'envio_correcto': envioCorrecto,
      'detalle_error': detalleError
    });

    // Si el formulario es válido, se puede enviar realmente
    if (envioCorrecto) {
      form.submit(); // enviar el formulario
    }
  });
});


function equalizeProductCardHeights() {
  // Ahora igualamos las alturas de las tarjetas
  document.querySelectorAll('.flickity-slider').forEach(slider => {
    
    const freeShippingTexts = slider.querySelectorAll('.lg-free-shipping--text');

    // Si hay textos y todos tienen visibility:hidden → ocultarlos temporalmente
    if (freeShippingTexts.length > 0) {
      const allHidden = Array.from(freeShippingTexts).every(
        p => window.getComputedStyle(p).visibility === 'hidden'
      );

      if (allHidden) {
        freeShippingTexts.forEach(p => {
          p.style.display = 'none';
        });
      }
    }

    const cards = slider.querySelectorAll('product-card');
    if (!cards.length) return;
    cards.forEach(card => card.style.minHeight = 'auto');
    const max = Math.max(...Array.from(cards).map(c => c.offsetHeight));
    cards.forEach(c => c.style.minHeight = `${max}px`);
  });
}

window.addEventListener('load', equalizeProductCardHeights);
window.addEventListener('resize', equalizeProductCardHeights);

document.addEventListener('DOMContentLoaded', function () {
  if (window.arcosGiftThresholdPopupInit) return;
  window.arcosGiftThresholdPopupInit = true;

  var THRESHOLD_CENTS = 4900;

  // Fechas de campaña
  var CAMPAIGN_START_TS = new Date('2026-04-07T00:00:00+02:00').getTime();
  var CAMPAIGN_END_TS = new Date('2026-04-19T23:59:59+02:00').getTime();

  var STORAGE_PREFIX = 'arcos-gift-threshold-49';
  var PREV_KEY = STORAGE_PREFIX + ':prev-eligible';
  var SHOWN_KEY = STORAGE_PREFIX + ':shown';

  var modal = document.getElementById('ArcosGiftThresholdModal');
  if (!modal) return;

  var chooseBtn = modal.querySelector('[data-arcos-gift-modal-choose]');
  var closeBtns = modal.querySelectorAll('[data-arcos-gift-modal-close]');

  function isCampaignActive() {
    var now = Date.now();
    return now >= CAMPAIGN_START_TS && now <= CAMPAIGN_END_TS;
  }

  function openModal() {
    modal.hidden = false;
    document.body.classList.add('arcos-gift-threshold-modal-open');
  }

  function closeModal() {
    modal.hidden = true;
    document.body.classList.remove('arcos-gift-threshold-modal-open');
  }

  function isPromoGift(item) {
    if (!item || !item.properties) return false;

    return (
      item.properties._agp_promo_role === 'gift' ||
      item.properties._promo_role === 'gift' ||
      item.properties._kite_promo_role === 'gift'
    );
  }

  function itemHasDiscount(item) {
    if (!item) return false;

    if (typeof item.total_discount === 'number' && item.total_discount > 0) {
      return true;
    }

    if (
      Array.isArray(item.line_level_discount_allocations) &&
      item.line_level_discount_allocations.length > 0
    ) {
      return true;
    }

    if (
      Array.isArray(item.discount_allocations) &&
      item.discount_allocations.length > 0
    ) {
      return true;
    }

    if (
      Array.isArray(item.discounts) &&
      item.discounts.length > 0
    ) {
      return true;
    }

    if (
      typeof item.final_line_price === 'number' &&
      typeof item.original_line_price === 'number' &&
      item.final_line_price < item.original_line_price
    ) {
      return true;
    }

    if (
      typeof item.final_price === 'number' &&
      typeof item.original_price === 'number' &&
      item.final_price < item.original_price
    ) {
      return true;
    }

    return false;
  }

  function getLinePriceCents(item) {
    if (!item) return 0;

    if (typeof item.final_line_price === 'number') return item.final_line_price;
    if (typeof item.original_line_price === 'number') return item.original_line_price;
    if (typeof item.line_price === 'number') return item.line_price;

    var unitPrice = 0;

    if (typeof item.final_price === 'number') {
      unitPrice = item.final_price;
    } else if (typeof item.price === 'number') {
      unitPrice = item.price;
    }

    return unitPrice * (item.quantity || 1);
  }

  function getEligibleSummary(cart) {
    var eligibleTotal = 0;
    var hasGiftInCart = false;

    if (!cart || !Array.isArray(cart.items)) {
      return {
        eligibleTotal: 0,
        hasGiftInCart: false
      };
    }

    cart.items.forEach(function (item) {
      if (isPromoGift(item)) {
        hasGiftInCart = true;
        return;
      }

      if (itemHasDiscount(item)) {
        return;
      }

      eligibleTotal += getLinePriceCents(item);
    });

    return {
      eligibleTotal: eligibleTotal,
      hasGiftInCart: hasGiftInCart
    };
  }

  async function fetchCart() {
    var response = await fetch('/cart.js', {
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('No se pudo cargar el carrito');
    }

    return response.json();
  }

  async function evaluateGiftThresholdPopup() {
    try {
      if (!isCampaignActive()) return;

      var cart = await fetchCart();
      var summary = getEligibleSummary(cart);
      var eligibleTotal = summary.eligibleTotal;
      var hasGiftInCart = summary.hasGiftInCart;

      var prevEligible = parseInt(sessionStorage.getItem(PREV_KEY), 10);
      var alreadyShown = sessionStorage.getItem(SHOWN_KEY) === '1';

      if (eligibleTotal < THRESHOLD_CENTS) {
        sessionStorage.removeItem(SHOWN_KEY);
      }

      var crossedThreshold = false;

      if (isNaN(prevEligible)) {
        crossedThreshold = eligibleTotal >= THRESHOLD_CENTS;
      } else {
        crossedThreshold =
          prevEligible < THRESHOLD_CENTS &&
          eligibleTotal >= THRESHOLD_CENTS;
      }

      if (crossedThreshold && !alreadyShown && !hasGiftInCart) {
        openModal();
        sessionStorage.setItem(SHOWN_KEY, '1');
      }

      sessionStorage.setItem(PREV_KEY, String(eligibleTotal));
    } catch (error) {
      console.warn('[Arcos Gift Popup]', error);
    }
  }

  closeBtns.forEach(function (btn) {
    btn.addEventListener('click', closeModal);
  });

  modal.addEventListener('click', function (event) {
    if (event.target === modal) {
      closeModal();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !modal.hidden) {
      closeModal();
    }
  });

  if (chooseBtn) {
  chooseBtn.addEventListener('click', function () {
    closeModal();
    window.location.href = 'https://arcouas.com/pages/producto-regalo';
  });
}

  document.addEventListener('line-item:change:end', function () {
    setTimeout(evaluateGiftThresholdPopup, 350);
  });

  document.addEventListener('cart:refresh', function () {
    setTimeout(evaluateGiftThresholdPopup, 350);
  });

  document.addEventListener('cart-drawer:open', function () {
    setTimeout(evaluateGiftThresholdPopup, 350);
  });

  window.addEventListener('load', function () {
    setTimeout(evaluateGiftThresholdPopup, 700);
  });
});

// ==============================
// BLOQUEAR EDICIÓN / BORRADO PARCIAL
// SERVICIO DE AFILADO EN CARRITO
// ==============================
(function () {
  var SHARPENING_HANDLE = 'servicio-de-afilado';
  var LANDING_URL = '/pages/afilado#beneficios-afilado';

  function getCartItemRows(scope) {
    scope = scope || document;
    return Array.from(scope.querySelectorAll('[data-cart-item]'));
  }

  function isSharpeningRow(row) {
    if (!row) return false;

    var link = row.querySelector('.cart-product-link');
    if (!link) return false;

    var href = link.getAttribute('href') || '';
    return href.indexOf('/products/' + SHARPENING_HANDLE) !== -1;
  }

  function getSharpeningRows(scope) {
    return getCartItemRows(scope).filter(isSharpeningRow);
  }

  function getSharpeningVariantLabel(raw) {
    raw = String(raw || '').trim().replace(/[–—]/g, '-');

    var map = {
      '1-4': 'Cuchillos 1 a 4 · precio base',
      '5-11': 'Cuchillos 5 a 11 · -10%',
      '12-35': 'Cuchillos 12 a 35 · -20%',
      '36+': 'A partir del cuchillo 36 · -25%'
    };

    return map[raw] || raw;
  }

  function relabelSharpeningRow(row) {
    if (!row) return;

    var optionEl =
      row.querySelector('.product-cart-item-options') ||
      row.querySelector('.cart-item__variant') ||
      row.querySelector('.product-option') ||
      row.querySelector('.cart-item__meta .product-option');

    if (!optionEl) return;

    var original = optionEl.getAttribute('data-original-variant') || optionEl.textContent.trim();
    optionEl.setAttribute('data-original-variant', original);
    optionEl.textContent = getSharpeningVariantLabel(original);
  }

  function disableQtyControls(row) {
    row.querySelectorAll('quantity-selector, .quantity.cart-update').forEach(function (control) {
      control.classList.add('sharpening-qty-locked');

      var input = control.querySelector('input.qty, input[name="updates[]"]');
      if (input) {
        input.readOnly = true;
        input.disabled = true;
        input.setAttribute('aria-readonly', 'true');
        input.setAttribute('inputmode', 'none');
        input.setAttribute('title', 'Modifica la cantidad desde la página de afilado');
        input.addEventListener('focus', function () {
          input.blur();
        });
      }

      control.querySelectorAll('button.minus, button.plus, button').forEach(function (btn) {
        if (btn.closest('.sharpening-service-actions')) return;
        btn.disabled = true;
        btn.tabIndex = -1;
        btn.setAttribute('aria-hidden', 'true');
      });
    });
  }

  function disablePartialRemove(row) {
    row.querySelectorAll(
      'a.remove, a[href*="/cart/change"], .cart-item-remove, [data-cart-remove], .product-quantity .remove'
    ).forEach(function (el) {
      if (el.closest('.sharpening-service-actions')) return;

      el.classList.add('sharpening-remove-locked');
      el.setAttribute('aria-hidden', 'true');
      el.tabIndex = -1;

      if (el.tagName === 'BUTTON') {
        el.disabled = true;
        el.type = 'button';
      }

      if (el.tagName === 'A') {
        el.dataset.originalHref = el.getAttribute('href') || '';
        el.removeAttribute('href');
      }

      el.addEventListener(
        'click',
        function (e) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        },
        true
      );
    });
  }

  function closeCartDrawer() {
    var drawer = document.querySelector('cart-drawer.cart-drawer, #Cart-Drawer, .cart-drawer');
    if (drawer) {
      drawer.classList.remove('active');
    }

    document.body.classList.remove('open-cart');
    document.body.classList.remove('open-cc');
  }

  function goToSharpeningLanding() {
    var isSharpeningPage = window.location.pathname.indexOf('/pages/afilado') !== -1;

    closeCartDrawer();

    if (!isSharpeningPage) {
      window.location.href = LANDING_URL;
      return;
    }

    var target =
      document.querySelector('#beneficios-afilado') ||
      document.querySelector('[id^="beneficios-afilado-"]') ||
      document.querySelector('#sharpening-service');

    setTimeout(function () {
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.replaceState(null, '', '/pages/afilado#beneficios-afilado');
      } else {
        window.location.href = LANDING_URL;
      }
    }, 180);
  }

  function createActionsBlock() {
    var wrap = document.createElement('div');
    wrap.className = 'sharpening-service-actions';

    var note = document.createElement('div');
    note.className = 'sharpening-qty-note';
    note.textContent =
      'Este servicio se calcula por tramos. Modifícalo desde la página de afilado o elimínalo completo.';
    wrap.appendChild(note);

    var actions = document.createElement('div');
    actions.className = 'sharpening-service-actions__buttons';

    var editBtn = document.createElement('button');
    editBtn.type = 'button';
    editBtn.className = 'sharpening-service-actions__edit';
    editBtn.textContent = 'Modificar afilado';
    editBtn.addEventListener('click', function () {
      goToSharpeningLanding();
    });
    actions.appendChild(editBtn);

    var removeBtn = document.createElement('button');
    removeBtn.type = 'button';
    removeBtn.className = 'sharpening-service-actions__remove';
    removeBtn.textContent = 'Eliminar servicio';
    removeBtn.addEventListener('click', function () {
      removeAllSharpeningLines();
    });
    actions.appendChild(removeBtn);

    wrap.appendChild(actions);
    return wrap;
  }

  function injectActions(row) {
    if (row.querySelector('.sharpening-service-actions')) return;

    var infoWrap =
      row.querySelector('.product-cart-item-info') ||
      row.querySelector('.product-name > .product-cart-item > div:last-child') ||
      row.querySelector('.product-quantity');

    if (!infoWrap) return;

    infoWrap.appendChild(createActionsBlock());
  }

  function isSharpeningCartItem(item) {
    if (!item) return false;

    var handle = item.handle || '';
    var url = item.url || '';
    var productTitle = item.product_title || '';
    var title = item.title || '';

    return (
      handle === SHARPENING_HANDLE ||
      url.indexOf('/products/' + SHARPENING_HANDLE) !== -1 ||
      productTitle.toLowerCase() === 'servicio de afilado' ||
      title.toLowerCase().indexOf('servicio de afilado') !== -1
    );
  }

  function removeAllSharpeningLines() {
    fetch('/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart_fetch_failed');
        return res.json();
      })
      .then(function (cart) {
        var updates = {};

        (cart.items || []).forEach(function (item) {
          if (isSharpeningCartItem(item) && item.key) {
            updates[item.key] = 0;
          }
        });

        if (!Object.keys(updates).length) return null;

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ updates: updates })
        });
      })
      .then(function (res) {
        if (res === null) return;
        if (!res.ok) throw new Error('remove_failed');
        return res.json();
      })
      .then(function () {
        closeCartDrawer();
        window.location.reload();
      })
      .catch(function () {
        window.location.href = '/cart';
      });
  }

  function lockSharpeningService(scope) {
    var rows = getSharpeningRows(scope);
    if (!rows.length) return;

    rows.forEach(function (row) {
      relabelSharpeningRow(row);
      disableQtyControls(row);
      disablePartialRemove(row);
      injectActions(row);
      row.classList.add('sharpening-service-row');
    });
  }

  var lockTimer = null;
  function queueLock(scope) {
    clearTimeout(lockTimer);
    lockTimer = setTimeout(function () {
      lockSharpeningService(scope || document);
    }, 80);
  }

  document.addEventListener('DOMContentLoaded', function () {
    queueLock(document);

    document.addEventListener('cart:updated', function () {
      queueLock(document);
    });

    document.addEventListener('cart:refresh', function () {
      queueLock(document);
    });

    document.addEventListener('line-item:change:end', function () {
      queueLock(document);
    });

    var observer = new MutationObserver(function () {
      queueLock(document);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });

  window.removeAllSharpeningLines = removeAllSharpeningLines;
})();